import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
  Tooltip,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { toast } from "react-toastify";
import { Close, DeleteOutline, RemoveRedEyeOutlined } from "@mui/icons-material";
import Axios from "../axios";
import { useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { Helmet } from "react-helmet";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useAuth } from "../auth/authContext";
import { findNavItemByPath } from "../navigation/navDataUtils";

const INITIAL_AFFILIATE_CUSTOMER_DATA = {
  overallLifetimeTotalBookings: "",
  overallLifetimeTotalSale: "",
  overallLifetimeCommission: "",
  overallLifetimeCommissionReceived: "",
  overallLifetimeCommissionPending: "",
  overallCurrentMonthTotalSale: "",
  overallCurrentMonthCommission: "",
  overallCurrentMonthTotalBookings: "",
  numberOfCustomers: "",
  numberOfActiveCustomersLifetime: "",
  numberOfActiveCustomersCurrentMonth: "",
  mainUser: null,
  affiliates: "",
  overallPendingCommissionBookings: [],
};

const Affiliates = () => {
  const { navData } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [openAffiliate, setOpenAffiliate] = useState(false);
  const [affiliates, setAffiliates] = useState();
  const [affiliateTypes, setAffiliateTypes] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};
  const [write, setWrite] = useState(false);
  //data for the CSV file
  const [id, setId] = useState();
  const [type, setType] = useState();
  const [commissionType, setCommissionType] = useState();
  const [newAffiliateType, setNewAffiliateType] = useState();
  const [newAffiliateEmail, setNewAffiliateEmail] = useState();
  const [updateAffiliate, setUpdateAffiliate] = useState(false);
  const [newUrl, setNewUrl] = useState();
  const [commissionValue, setCommissionValue] = useState();
  const [commissionOnTopOf, setCommissionOnTopOf] = useState();
  const [commisionPayoutPeriod, setCommisionPayoutPeriod] = useState();
  const [description, setDescription] = useState();
  const [value, setValue] = useState("1");

  const [opendel, setOpendel] = useState({ status: false, id: null });
  const [openAffiliatedel, setOpenAffiliatedel] = useState({
    status: false,
    id: null,
  });
  const [selectedBookings, setSelectedBookings] = useState([]);

  const handleCheckboxChange = (bookingId) => {
    setSelectedBookings((prevSelected) =>
      prevSelected.includes(bookingId)
        ? prevSelected.filter((id) => id !== bookingId)
        : [...prevSelected, bookingId]
    );
  };

  const handlePayOut = () => {
    const selectedBookingDetails = affiliateCustomerData?.overallPendingCommissionBookings.filter((booking) =>
      selectedBookings.includes(booking._id)
    );
    const bookingIds = selectedBookingDetails.map(booking => booking.bookingId);

    Axios.post(process.env.REACT_APP_BACKEND + "updateAffiliateCommissionPayOut", bookingIds)
      .then((resp) => {
        setAffiliateCustomerData(INITIAL_AFFILIATE_CUSTOMER_DATA);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = findNavItemByPath(navData, currentPath);
    setWrite(Boolean(matchingNavItem?.write));
  }, [location.pathname, navData]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getAffiliateTypes();
    getAffiliates();
  }, [page, search]);

  const getAffiliateTypes = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-affiliatetypes")
      .then((resp) => {
        setAffiliateTypes(resp?.data?.data?.docs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  const getAffiliates = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-affiliates", {
      page: page + 1,
      limit: 10,
      search,
    })
      .then((resp) => {
        setAffiliates(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    search: true,
    viewColumns: false,
    rowsPerPageOptions: [],
    serverSide: true,
    count: count,
    page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      setPage(0);
      setSearch(searchText || "");
    },
  };

  const columns = [
    {
      name: "type",
      label: "Type",
      options: {
        filter: true,
        sort: false,
      },
    }, {
      name: "commissionType",
      label: "Commission Type",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "commissionValue",
      label: "Commission Value",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "commissionOnTopOf",
      label: "Commission On Top Of",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value + " rate";
        },
      },
    },
    {
      name: "commisionPayoutPeriod",
      label: "commision Payout Period",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: true,
        sort: false,
      },
    },
    // {
    //   name: "validity",
    //   label: "Validity",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRenderLite: (dataIndex) => {
    //       if (referrals[dataIndex]?.validity) {
    //         const date = new Date(referrals[dataIndex]?.validity);
    //         const formatted = date.toISOString().split("T")[0];
    //         return <>{formatted}</>;
    //       } else {
    //         return <></>;
    //       }
    //     },
    //   },
    // },

    write && {
      name: "",
      label: "Actions",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {write ? (
                <>
                  {/* <Switch
                    checked={affiliateTypes[dataIndex]?.active}
                    onChange={(event) =>
                      handleAffiliateTypeUpdate(
                        event,
                        affiliateTypes[dataIndex]?._id,
                        "active"
                      )
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  /> */}
                  <EditIcon
                    style={{
                      color: "red",
                      fontSize: "24px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      openAffiliateTypeUpdate(affiliateTypes[dataIndex])
                    }
                  />
                  <DeleteOutline
                    style={{
                      color: "red",
                      fontSize: "24px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setOpenAffiliatedel({
                        status: true,
                        id: affiliateTypes[dataIndex]?._id,
                      })
                    }
                  />
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    },
  ].filter(Boolean);
  const columnsAffiliate = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "mail",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "affiliateDetails",
      label: "Affiliate Type",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // Extract the affiliateType from the nested object
          const rowData = tableMeta.rowData;
          const affiliateDetails = rowData[2]; // Adjust index based on column order
          return affiliateDetails?.affiliateType || "N/A";
        },
      },
    },
    {
      name: "affiliateDetails",
      label: "Affiliate Url",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // Extract the affiliateType from the nested object
          const rowData = tableMeta.rowData;
          const affiliateDetails = rowData[2]; // Adjust index based on column order
          return affiliateDetails?.affiliateLink || "N/A";
        },
      },
    },
    {
      name: "affiliateProfile",
      label: "Affiliate Profile",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Tooltip title="Affiliate Profile">
              <IconButton
                aria-label="Affiliate Profile"
                onClick={() => handleAffiliateCustomersData(affiliates[dataIndex]?._id)}
              >
                <RemoveRedEyeOutlined className="icon-size" />
              </IconButton>
            </Tooltip>
          );
        },
      },
    },

    write && {
      name: "",
      label: "Actions",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {write ? (
                <>
                  {/* <Switch
                    checked={affiliateTypes[dataIndex]?.active}
                    onChange={(event) =>
                      handleAffiliateTypeUpdate(
                        event,
                        affiliateTypes[dataIndex]?._id,
                        "active"
                      )
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  /> */}
                  <EditIcon
                    style={{
                      color: "red",
                      fontSize: "24px",
                      cursor: "pointer",
                    }}
                    onClick={() => openAffiliateUpdate(affiliates[dataIndex])}
                  />
                  <DeleteOutline
                    style={{
                      color: "red",
                      fontSize: "24px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setOpendel({
                        status: true,
                        id: affiliates[dataIndex]?._id,
                      })
                    }
                  />
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    },
  ].filter(Boolean);
  const deleteAffiliateType = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "delete-affiliatetype", {
      id: openAffiliatedel?.id,
    })
      .then((resp) => {
        getAffiliateTypes();
        setOpendel({ status: false, id: null });
        setOpenAffiliatedel({ status: false, id: null });
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const deleteAffiliate = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "delete-affiliate", {
      id: opendel?.id,
    })
      .then((resp) => {
        getAffiliates();
        setOpendel({ status: false, id: null });
        setOpenAffiliatedel({ status: false, id: null });
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const openAffiliateTypeUpdate = (data) => {
    setId(data._id);
    setType(data.type)
    setCommissionType(data.commissionType);
    setCommissionValue(data.commissionValue);
    setCommissionOnTopOf(data.commissionOnTopOf);
    setCommisionPayoutPeriod(data.commisionPayoutPeriod);
    setDescription(data.description);
    setOpen(true);
  };
  const openAffiliateUpdate = (data) => {
    setUpdateAffiliate(true);
    setId(data._id);
    setNewAffiliateEmail(data.mail);
    setNewAffiliateType(data.affiliateDetails.affiliateTypeId);
    setNewUrl(data.affiliateDetails.affiliateLink);
    setOpenAffiliate(true);
  };
  const handleAffiliateTypeUpdate = () => {
    if (
      type === "" ||
      type === null ||
      type === undefined
    ) {
      toast.error("type is required");
      return;
    }
    if (
      commissionType === "" ||
      commissionType === null ||
      commissionType === undefined
    ) {
      toast.error("Comission type is required");
      return;
    }
    if (
      commissionValue === "" ||
      commissionValue === null ||
      commissionValue === undefined
    ) {
      toast.error("Comission value is required");
      return;
    }
    if (
      commissionOnTopOf === "" ||
      commissionOnTopOf === null ||
      commissionOnTopOf === undefined
    ) {
      toast.error("Comission on top of is required");
      return;
    }
    if (
      commisionPayoutPeriod === "" ||
      commisionPayoutPeriod === null ||
      commisionPayoutPeriod === undefined
    ) {
      toast.error("Comission pay period is required");
      return;
    }
    if (
      description === "" ||
      description === null ||
      description === undefined
    ) {
      toast.error("Comission description is required");
      return;
    }
    const data = {
      id,
      type,
      commissionType,
      commissionValue,
      commissionOnTopOf,
      commisionPayoutPeriod,
      description,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "update-affiliatetype", data)
      .then((resp) => {
        // setAllHotels(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        getAffiliateTypes();
        setId("");
        setType("");
        setCommissionType("");
        setCommissionValue("");
        setCommissionOnTopOf("");
        setCommisionPayoutPeriod("");
        setDescription("");
        setCommissionType("");
        setNewAffiliateType("");
        setNewAffiliateEmail("");
        setNewUrl("");
        setOpen(false);
        setOpenAffiliate(false);
        setUpdateAffiliate(false);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleClose = () => {
    setOpen(false);
    setOpenAffiliate(false);
    setUpdateAffiliate(false);
    setOpendel({ status: false, id: null });
    setOpenAffiliatedel({ status: false, id: null });
    setId("");
    setType("");
    setCommissionType("");
    setCommissionValue("");
    setCommissionOnTopOf("");
    setCommisionPayoutPeriod("");
    setDescription("");
    setCommissionType("");
    setNewAffiliateType("");
    setNewAffiliateEmail("");
    setNewUrl("");
    setAffiliateCustomerData(INITIAL_AFFILIATE_CUSTOMER_DATA);
    setSelectedBookings([]);
  };
  const addAffiliateType = () => {
    if (
      type === "" ||
      type === null ||
      type === undefined
    ) {
      toast.error("type is required");
      return;
    }
    if (
      commissionType === "" ||
      commissionType === null ||
      commissionType === undefined
    ) {
      toast.error("Comission type is required");
      return;
    }
    if (
      commissionValue === "" ||
      commissionValue === null ||
      commissionValue === undefined
    ) {
      toast.error("Comission value is required");
      return;
    }
    if (
      commissionOnTopOf === "" ||
      commissionOnTopOf === null ||
      commissionOnTopOf === undefined
    ) {
      toast.error("Comission on top of is required");
      return;
    }
    if (
      commisionPayoutPeriod === "" ||
      commisionPayoutPeriod === null ||
      commisionPayoutPeriod === undefined
    ) {
      toast.error("Comission pay period is required");
      return;
    }
    if (
      description === "" ||
      description === null ||
      description === undefined
    ) {
      toast.error("Comission description is required");
      return;
    }
    let data = {
      type,
      commissionType,
      commissionValue,
      commissionOnTopOf,
      commisionPayoutPeriod,
      description,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "create-affiliatetype", data)
      .then((resp) => {
        getAffiliateTypes();
        setId("");
        setType("")
        setCommissionType("");
        setCommissionValue("");
        setCommissionOnTopOf("");
        setCommisionPayoutPeriod("");
        setDescription("");
        setCommissionType("");
        setNewAffiliateType("");
        setNewAffiliateEmail("");
        setNewUrl("");
        setOpen(false);
        setOpenAffiliate(false);
        setUpdateAffiliate(false);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          (err && err.response && err.response.data && err.response.data.message) ||
            "Failed to create affiliate type"
        );
      });
  };


  const [affiliateCustomerData, setAffiliateCustomerData] = useState(
    INITIAL_AFFILIATE_CUSTOMER_DATA
  );

  const handleAffiliateCustomersData = (userId) => {
    let data = {
      userId: userId,
    };
    setSelectedBookings([]);
    Axios
      .post(process.env.REACT_APP_BACKEND + "getAffiliateCustomersData", data)
      .then((resp) => {
        setAffiliateCustomerData({
          overallLifetimeTotalBookings: resp.data.data.overallLifetimeTotalBookings,
          overallLifetimeTotalSale: resp.data.data.overallLifetimeTotalSale,
          overallLifetimeCommissionReceived: resp.data.data.overallLifetimeCommissionReceived,
          overallLifetimeCommissionPending: resp.data.data.overallLifetimeCommissionPending,
          overallCurrentMonthCommission: resp.data.data.overallCurrentMonthCommission,
          overallCurrentMonthTotalSale: resp.data.data.overallCurrentMonthTotalSale,
          overallCurrentMonthTotalBookings: resp.data.data.overallCurrentMonthTotalBookings,
          numberOfCustomers: resp.data.data.numberOfCustomers,
          numberOfActiveCustomersLifetime: resp.data.data.numberOfActiveCustomersLifetime,
          numberOfActiveCustomersCurrentMonth: resp.data.data.numberOfActiveCustomersCurrentMonth,
          mainUser: resp.data.data.mainUser,
          affiliates: resp.data.data.affiliates,
          overallPendingCommissionBookings: resp.data.data.overallPendingCommissionBookings
          //affiliates: resp.data.data.affiliates, enable this later on if needed
        });
      });
  };


  const addNewAffiliate = () => {
    if (
      newAffiliateType === "" ||
      newAffiliateType === null ||
      newAffiliateType === undefined
    ) {
      toast.error("Affiliate type is required");
      return;
    }
    if (
      newAffiliateEmail === "" ||
      newAffiliateEmail === null ||
      newAffiliateEmail === undefined
    ) {
      toast.error("Affiliate email is required");
      return;
    }
    if (newUrl === "" || newUrl === null || newUrl === undefined) {
      toast.error("Affiliate url is required");
      return;
    }
    let data = {
      mail: newAffiliateEmail,
      affiliateLink: newUrl,
      affiliateType: newAffiliateType,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "create-affiliate", data)
      .then((resp) => {
        getAffiliates();
        setId("");
        setCommissionType("");
        setCommissionValue("");
        setCommissionOnTopOf("");
        setCommisionPayoutPeriod("");
        setDescription("");
        setCommissionType("");
        setNewAffiliateType("");
        setNewAffiliateEmail("");
        setNewUrl("");
        setOpen(false);
        setOpenAffiliate(false);
        setUpdateAffiliate(false);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          (err && err.response && err.response.data && err.response.data.message) ||
            "Failed to create affiliate"
        );
      });
  };
  const updateAffiliateCall = () => {
    if (
      newAffiliateType === "" ||
      newAffiliateType === null ||
      newAffiliateType === undefined
    ) {
      toast.error("Affiliate type is required");
      return;
    }
    if (
      newAffiliateEmail === "" ||
      newAffiliateEmail === null ||
      newAffiliateEmail === undefined
    ) {
      toast.error("Affiliate email is required");
      return;
    }
    if (newUrl === "" || newUrl === null || newUrl === undefined) {
      toast.error("Affiliate url is required");
      return;
    }
    let data = {
      id: id,
      affiliateLink: newUrl,
      affiliateType: newAffiliateType,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "update-affiliate", data)
      .then((resp) => {
        getAffiliates();
        setId("");
        setCommissionType("");
        setCommissionValue("");
        setCommissionOnTopOf("");
        setCommisionPayoutPeriod("");
        setDescription("");
        setCommissionType("");
        setNewAffiliateType("");
        setNewAffiliateEmail("");
        setNewUrl("");
        setOpen(false);
        setOpenAffiliate(false);
        setUpdateAffiliate(false);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          (err && err.response && err.response.data && err.response.data.message) ||
            "Failed to update affiliate"
        );
      });
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-Trip</title>
        <meta name="Trip List" content="Trip List for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-4">
        <h2>Affiliates</h2>
      </div>
      <Tabs
        value={value}
        onChange={handleChange}
        className="mb-4"
        sx={{
          "& button": {
            borderRadius: 2,
            color: "#000", // Default text color
            transition: "all 0.3s", // Smooth transition
          },
          "& button:hover": {
            color: "#3dd2cc", // Hover color
          },
          "& button.Mui-selected": {
            color: "#3dd2cc", // Active tab color
            fontWeight: "bold", // Optional: Make active tab bold
            // backgroundColor: "rgba(61, 210, 204, 0.1)", // Light background for active
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "black", // Change underline color
          },
        }}
      >
        <Tab className="fs-14 fw-600 p-2 mr-2" value="1" label="Affiliates" />
        <Tab
          className="fs-14 fw-600 p-2 mr-2"
          value="2"
          label="Affiliate Types"
        />
      </Tabs>
      {value === "1" ? (
        <>
          <div className="d-flex justify-content-end mb-4">
            <Button
              className="w7 sevenly-btn text-white "
              onClick={() => setOpenAffiliate(true)}
            >
              Add
            </Button>
          </div>
          <MUIDataTable
            title={"Affiliates"}
            data={affiliates}
            columns={columnsAffiliate}
            options={options}
          />
        </>
      ) : value === "2" ? (
        <>
          <div className="d-flex justify-content-end mb-4">
            <Button
              className="w7 sevenly-btn text-white "
              onClick={() => setOpen(true)}
            >
              Add
            </Button>
          </div>
          <MUIDataTable
            title={"Affiliate Types"}
            data={affiliateTypes}
            columns={columns}
            options={options}
          />
        </>
      ) : null}

      {affiliateTypes ? (
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          fullWidth={true}
          open={openAffiliate}
        >
          <div className="d-flex justify-content-between align-center p-3">
            <h3>{updateAffiliate ? "Update" : "Add"} Affiliate</h3>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
          <DialogContent dividers>
            <InputLabel id="affiliateType">Affiliate Type</InputLabel>
            <Select
              labelId="affiliateType"
              id="affiliateType"
              required
              fullWidth
              className="my-2"
              label="Affiliate Type"
              onChange={(event) => setNewAffiliateType(event.target.value)}
              value={newAffiliateType}
            >
              <MenuItem value={""}>
                <em>None</em>
              </MenuItem>
              {affiliateTypes.map((item) => (
                <MenuItem key={item._id} value={item._id}>
                  {item.description}
                </MenuItem>
              ))}
            </Select>
            <TextField
              label="Email"
              variant="outlined"
              required
              fullWidth
              className="my-2"
              placeholder="Enter email"
              name="email"
              disabled={updateAffiliate}
              onChange={(event) => setNewAffiliateEmail(event.target.value)}
              value={newAffiliateEmail}
            />
            <TextField
              label="Url"
              variant="outlined"
              required
              fullWidth
              className="my-2"
              placeholder="Enter affiliate url"
              name="url"
              onChange={(event) => setNewUrl(event.target.value)}
              value={newUrl}
            />
          </DialogContent>
          <DialogActions>
            <Button className="cancel-button" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              className="submit-button"
              variant="contained"
              onClick={updateAffiliate ? updateAffiliateCall : addNewAffiliate}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <></>
      )}

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>{id ? "Update" : "Add"} a Type</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <TextField
            label="Type"
            variant="outlined"
            required
            fullWidth
            className="my-2"
            placeholder="Enter Type value(Type-1, Type-2 etc.)"
            name="type"
            onChange={(event) => setType(event.target.value)}
            value={type}
          />
          <InputLabel id="commissionType">Commission Type</InputLabel>
          <Select
            labelId="commissionType"
            id="commissionType"
            required
            fullWidth
            className="my-2"
            label="Commission Type"
            onChange={(event) => setCommissionType(event.target.value)}
            value={commissionType}
          >
            <MenuItem value={""}>
              <em>None</em>
            </MenuItem>
            <MenuItem value={"percent"}>Percentage</MenuItem>
            <MenuItem value={"amount"}>Amount</MenuItem>
          </Select>
          <InputLabel id="commissionOnTopOf">Commission On</InputLabel>
          <Select
            labelId="commissionOnTopOf"
            id="commissionOnTopOf"
            required
            fullWidth
            className="my-2"
            label="Commission On"
            onChange={(event) => setCommissionOnTopOf(event.target.value)}
            value={commissionOnTopOf}
          >
            <MenuItem value={""}>
              <em>None</em>
            </MenuItem>
            <MenuItem value={"net"}>Net Rate</MenuItem>
            <MenuItem value={"sell"}>Sell Rate</MenuItem>
          </Select>
          <InputLabel id="commisionPayoutPeriod">Pay Period</InputLabel>
          <Select
            labelId="commisionPayoutPeriod"
            id="commisionPayoutPeriod"
            required
            fullWidth
            className="my-2"
            label="Pay Period"
            onChange={(event) => setCommisionPayoutPeriod(event.target.value)}
            value={commisionPayoutPeriod}
          >
            <MenuItem value={""}>
              <em>None</em>
            </MenuItem>
            <MenuItem value={"monthly"}>Monthly</MenuItem>
            <MenuItem value={"yearly"}>Yearly</MenuItem>
          </Select>
          <TextField
            label="Commission Value"
            variant="outlined"
            required
            fullWidth
            className="my-2"
            placeholder="Enter commission value"
            name="commissionValue"
            onChange={(event) => setCommissionValue(event.target.value)}
            value={commissionValue}
          />
          <TextField
            label="Description"
            variant="outlined"
            required
            fullWidth
            className="my-2"
            placeholder="Enter description"
            name="decription"
            onChange={(event) => setDescription(event.target.value)}
            value={description}
          />
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={id ? handleAffiliateTypeUpdate : addAffiliateType}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel?.status || openAffiliatedel?.status}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>Delete affiliate{openAffiliatedel?.status ? "" : " type"}</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          Are you sure you want to delete the affiliate
          {opendel?.status ? "" : " type"}?
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={opendel.status ? deleteAffiliate : deleteAffiliateType}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        onClose={handleClose}
        aria-labelledby="transaction-dialog-title"
        fullWidth
        open={Boolean(affiliateCustomerData?.mainUser)}
        maxWidth="xl"
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h2 id="transaction-dialog-title">Affiliate Profile</h2>

          <IconButton onClick={handleClose} aria-label="close">
            <Close />
          </IconButton>
        </div>

        <DialogContent dividers>
          <div className="col-md-6">
            <p className="fs-16 fw-600 mb-3">
              Name:
              <span className="fw-500 fs-18">
                {affiliateCustomerData?.mainUser?.name}
              </span>
            </p>
            <p className="fs-16 fw-600 mb-3">
              Email:
              <span className="fw-500 fs-18">
                {affiliateCustomerData?.mainUser?.description}
              </span>
            </p>
            <p className="fs-16 fw-600 mb-3">
              Commission Value:
              <span className="fw-500 fs-18">
                {affiliateCustomerData.mainUser?.commissionValue && !isNaN(+affiliateCustomerData.mainUser?.commissionValue)? (+affiliateCustomerData.mainUser?.commissionValue).toFixed(2): "0.00"}%
              </span>
            </p>
          </div>
          <div className="viewDetials">
            <div className="row">
              <div className="col-md-6">
                <h2> Lifetime Metrics</h2>
                <hr className="my-3" />
                <p className="fs-16 fw-600 mb-3">
                  Total Affiliates:
                  <span className="fw-500 fs-18">
                    {affiliateCustomerData?.numberOfCustomers}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-3">
                  Active Users Lifetime:
                  <span className="fw-500 fs-18">
                    {affiliateCustomerData?.numberOfActiveCustomersLifetime}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-3">
                  Lifetime Bookings:
                  <span className="fw-500 fs-18">
                    {affiliateCustomerData?.overallLifetimeTotalBookings}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-3">
                  Current Month Bookings:
                  <span className="fw-500 fs-18">
                    {affiliateCustomerData?.overallCurrentMonthTotalBookings}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-3">
                  Lifetime Sales:
                  <span className="fw-500 fs-18">
                    ${affiliateCustomerData.overallLifetimeTotalSale && !isNaN(+affiliateCustomerData.overallLifetimeTotalSale)? (+affiliateCustomerData.overallLifetimeTotalSale).toFixed(2): "0.00"}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-3">
                  Commission Received:
                  <span className="fw-500 fs-18">
                    ${affiliateCustomerData.overallLifetimeCommissionReceived && !isNaN(+affiliateCustomerData.overallLifetimeCommissionReceived)? (+affiliateCustomerData.overallLifetimeCommissionReceived).toFixed(2): "0.00"}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-3">
                  Commission Pending:
                  <span className="fw-500 fs-18">
                    ${affiliateCustomerData.overallLifetimeCommissionPending && !isNaN(+affiliateCustomerData.overallLifetimeCommissionPending)? (+affiliateCustomerData.overallLifetimeCommissionPending).toFixed(2): "0.00"}
                  </span>
                </p>

              </div>

              <div className="col-md-6">
                <h2> This Month Metrics</h2>
                <hr className="my-3" />
                <p className="fs-16 fw-600 mb-3">
                  Active Users This Month:
                  <span className="fw-500 fs-18">
                    {affiliateCustomerData?.numberOfActiveCustomersCurrentMonth}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-3">
                  Current Month Sales:
                  <span className="fw-500 fs-18">
                     ${affiliateCustomerData.overallCurrentMonthTotalSale && !isNaN(+affiliateCustomerData.overallCurrentMonthTotalSale)? (+affiliateCustomerData.overallCurrentMonthTotalSale).toFixed(2): "0.00"}
                  </span>
                </p>
                <p className="fs-16 fw-600 mb-3">
                  Current Month Commission:
                  <span className="fw-500 fs-18">
                     ${affiliateCustomerData.overallCurrentMonthCommission && !isNaN(+affiliateCustomerData.overallCurrentMonthCommission)? (+affiliateCustomerData.overallCurrentMonthCommission).toFixed(2): "0.00"}
                  </span>
                </p>
              </div>

              <div className="mt-5">
                <h2 className="mb-3">Pending Commission Bookings</h2>
                <hr className="my-3" />
                {affiliateCustomerData?.overallPendingCommissionBookings?.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Booking ID</th>
                            <th>Hotel Name</th>
                            <th>Customer Name</th>
                            <th>Customer Email</th>
                            <th>Customer City</th>
                            <th>Total Amount</th>
                            <th>Commission Amount</th>
                            <th>Booking Date</th>
                            <th>Commission Paid</th>
                            <th>Select</th>
                          </tr>
                        </thead>
                        <tbody>
                          {affiliateCustomerData?.overallPendingCommissionBookings.map((booking) => {
                            const bookingId = booking._id?.$oid || booking._id;
                            return (
                              <tr key={bookingId}>
                                <td>{booking.bookingId}</td>
                                <td>{booking.hotelName}</td>
                                <td>{booking.customerName}</td>
                                <td>{booking.customerEmail}</td>
                                <td>{booking.customerCity}</td>
                                <td>${booking.totalAmount.toFixed(2)}</td>
                                <td>${booking.commissionAmount.toFixed(2)}</td>
                                <td>{new Date(booking.creationDate).toLocaleDateString()}</td>
                                <td>{booking.isCommissionPayedOut ? "Yes" : "No"}</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedBookings.includes(bookingId)}
                                    onChange={() => handleCheckboxChange(bookingId)}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        className="submit-button"
                        variant="contained"
                        onClick={handlePayOut}
                        disabled={selectedBookings.length === 0}
                      >
                        Pay Out
                      </Button>
                    </div>
                  </>
                ) : (
                  <p className="text-muted">No pending commission bookings found.</p>
                )}
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>



    </>
  );
};
export default Affiliates;
